import { InfaceEnv, Fetch, generateUUID } from '@inface-sdk/common'

const LOCAL_STORAGE = {
  TOY_WEB_SDK: {
    UUID: '_ifinsign_front.toy_web_sdk.uuid',
  },
}

const TERMS = {
  NEED_TO_AGREE: 0,
  AGREE: 1,
  NOT_AGREE: 2,
}

class PersistenceService {
  _getUuidLS() {
    const uuid = localStorage.getItem(LOCAL_STORAGE.TOY_WEB_SDK.UUID)
    if (uuid) {
      try {
        return InfaceEnv.decrypt(uuid)
      } catch (error) {
        //
      }
    }
  }

  _setUuidLS(uuid) {
    localStorage.setItem(LOCAL_STORAGE.TOY_WEB_SDK.UUID, InfaceEnv.encrypt(uuid))
  }
  
  async syncedUuid() {
    const lsUuid = this._getUuidLS()

    if (lsUuid) {
      // Happy PATH
      console.debug(`[web-auth] getValidUuid happay path! uuid[${lsUuid}] matched`)
      return lsUuid
    } else {
      const uuid = generateUUID()
      console.log(`[web-auth] CASE 1. LS 없어서 UUID[${uuid}] 생성 및 저장`)
      this._setUuidLS(uuid)
      return uuid
    }
  }
}

class ToyTermsService {
  constructor(conf = {}) {
    const termsChecked = document.querySelector('meta[type="inface"][name="additional-terms"]')?.getAttribute('data-checked')
    
    this.gid = conf.gid
    this.locale = conf.locale
    this.webToken = conf.webToken
    this.boltApiUrl = conf.boltApiUrl
    this.persistenceService = new PersistenceService()
    this.checkAdditionalTerms = (termsChecked === 'true' || conf.checkAdditionalTerms) ?? false // meta tag 가 최우선
  }

  _filterTermsToAgree(termsAgree = []) {
    if (!Array.isArray(termsAgree)) return []
    return termsAgree.filter(terms => `${terms.isAgree}` === `${TERMS.NEED_TO_AGREE}`)
  }

  async getTermsWithWebToken(options = {}) {
    const gid = options?.gid ?? this.gid
    const webToken = options?.webToken ?? this.webToken
    const locale = options?.locale ?? this.locale

    try {
      const url = `${this.boltApiUrl}/sdk/signInForWeb.nx`
      const boltLocale = (locale || navigator.language || '').replace('-', '_')
      const body = {
        os: 'desktop',
        locale: boltLocale,
        uuid: await this.persistenceService.syncedUuid(),
      }

      const response = await Fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          gid,
          'ias-webtoken': webToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
      })

      if (!response.ok) {
        return { success: false, error: response }
      }

      const data = await response.json()
      console.log('signInForWeb data', data)
      const { result, errorCode } = data
      if (errorCode === 0) {
        const { guid, termsAgree, iasTicket: ticket } = result || {}
        return { success: true, data: { guid, termsAgree: this._filterTermsToAgree(termsAgree), ticket } }
      }
      
      return { success: false, error: { rawResponseData: data } }
    } catch(error) {
      console.error(error)
      throw error
    }
  }

  async processCheckTerms() {
    console.log('processCheckTerms')
    console.log('checkAdditionalTerms', this.checkAdditionalTerms)
    if (!this.checkAdditionalTerms) {
      return { success: true }
    }

    // 추가 약관 조회
    const { success, data } = await this.getTermsWithWebToken()
    return { success, data }
  }
}

export default ToyTermsService
